import * as React from "react";
import Payment from "../../../model/payment/Payment";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import {InvoiceActivityPaymentItem} from "../activityStream/items/InvoiceActivityPaymentItem";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./paymentConfirmation.scss";

interface IProps {
	payment: Payment,
	confirmFullPayment: () => void,
	isLoading: boolean,
	renderBodyMessage: () => JSX.Element
}

export const FullPaymentConfirmation: React.SFC<IProps> = (props) => {
	if (!props.payment) {
		return null;
	}
	return (
		<div className="c-payment-confirmation">
			<div className="c-payment-confirmation_inside-container">
				<div className="c-common-details_activity-stream-item-container">
					<InvoiceActivityPaymentItem icon={Icon.CheckMark}
												iconColor={IconColor.White}
												iconVariant={"green"}
												hideCreator={true}
												renderBodyMessage={props.renderBodyMessage}
												activity={props.payment}/>
				</div>
				<div className="c-payment-confirmation_buttons-container">
					<ButtonPrimary label={"Confirm full payment"}
								   isLoading={props.isLoading}
								   disabled={props.isLoading}
								   onClick={props.confirmFullPayment}/>
				</div>
			</div>
		</div>
	)
};
